<template>
  <div class="content">
    <h1>System Policies</h1>
  </div>
</template>

<script>
export default {
  name: "DocumentsSysPol"
};
</script>

<style scoped lang="scss">
.document {
  max-width: 35rem;
  margin: 0 auto;
}
</style>
